export default __webpack_public_path__ + "dbcc7f217fd9909214aae5272e33b6ed.jpg";